import sf90PhaserIcon from "../../../../static/images/TSDD/pedals/sf90_phaser.webp"
import VE8Icon from "../../../../static/images/TSDD/pedals/ve8.webp"
import dinoCompIcon from "../../../../static/images/TSDD/pedals/dino_comp.webp"
import od296Icon from "../../../../static/images/TSDD/pedals/od296.webp"


// PHASER AUDIO
import phaserDry from "../../../../static/audio/TSDD/Pedals/Phaser/phaser_bypass.mp3"
import phaserSlow from "../../../../static/audio/TSDD/Pedals/Phaser/phaser_slow.mp3"
import phaserMid from "../../../../static/audio/TSDD/Pedals/Phaser/phaser_mid.mp3"
import phaserFast from "../../../../static/audio/TSDD/Pedals/Phaser/phaser_fast.mp3"

// COMP AUDIO
import compDry from "../../../../static/audio/TSDD/Pedals/Comp/comp_dry.mp3"
import compMin from "../../../../static/audio/TSDD/Pedals/Comp/comp_min_comp.mp3"
import compMid from "../../../../static/audio/TSDD/Pedals/Comp/comp_mid_comp.mp3"
import compMax from "../../../../static/audio/TSDD/Pedals/Comp/comp_max_comp.mp3"

// VE8 AUDIO
import eqAudioDry from "../../../../static/audio/TSDD/Pedals/EQ/eq_pedal_bypass.mp3"
import eqAudioClean from "../../../../static/audio/TSDD/Pedals/EQ/eq_pedal_clean_boost.mp3"
import eqAudioDirty from "../../../../static/audio/TSDD/Pedals/EQ/eq_pedal_dirty_boost.mp3"
import eqAudioFuzz from "../../../../static/audio/TSDD/Pedals/EQ/eq_pedal_fuzz.mp3"

// OD AUDIO
import odAudioDry from "../../../../static/audio/TSDD/Pedals/OD296/overdrive_dry.mp3"
import odAudioDrive from "../../../../static/audio/TSDD/Pedals/OD296/overdrive_standard_drive.mp3"
import odAudioDriveFat from "../../../../static/audio/TSDD/Pedals/OD296/overdrive_standard_drive_fat.mp3"
import odAudioDriveClean from "../../../../static/audio/TSDD/Pedals/OD296/overdrive_clean_boost.mp3"

const SF90 = {
  id: "pedal-1",
  name: "SF-90 Phaser",
  subtitle: "Classic Phaser",
  image: sf90PhaserIcon,
  tags: ["Phaser"],
  modes: [
    {
      id: "phaser_slow",
      name: "Slow",
      description:
        "Slowest possible setting, creating some gentle movement.",
      audio: phaserSlow,
      icon: sf90PhaserIcon,
    },
    {
      id: "phaser_mid",
      name: "Middle",
      description:
        "Mid speed setting.",
      audio: phaserMid,
      icon: sf90PhaserIcon,
    },
    {
      id: "phaser_fast",
      name: "Fast",
      description:
        "Fastest speed setting.",
      audio: phaserFast,
      icon: sf90PhaserIcon,
    },
    {
      id: "phaser_bypass",
      name: "Bypassed",
      description:
        "Dry amplifier tone running through the Hammerfaust.",
      audio: phaserDry,
      icon: sf90PhaserIcon,
    },
  ],
}

const VE8 = {
  id: "pedal-2",
  name: "VE-8 Graphic EQ Pedal",
  subtitle: "8-band Graphic EQ with built in overdrive",
  image: VE8Icon,
  tags: ["EQ", "Boost", "Drive"],
  modes: [
    {
      id: "eq_clean",
      name: "Clean Boost",
      description:
        "Clean mid boost, boosting the input of the amplifier.",
      audio: eqAudioClean,
      icon: VE8Icon,
    },
    {
      id: "eq_dirty",
      name: "Dirty Boost",
      description:
        "Overdrive style boost, making for a more compressed input to the amplifier.",
      audio: eqAudioDirty,
      icon: VE8Icon,
    },
    {
      id: "eq_fuzz",
      name: "Fuzzy",
      description:
        "Fuzzy tone using the dirt circuit in the pedal, boosting all frequencies to overload everyting.",
      audio: eqAudioFuzz,
      icon: VE8Icon,
    },
    {
      id: "eq_bypass",
      name: "Bypassed",
      description:
        "Dry amplifier tone running through the Icona with everything at 5",
      audio: eqAudioDry,
      icon: VE8Icon,
    },
  ],
}

const DINO = {
  id: "pedal-3",
  name: "Dino Compressor",
  subtitle: "Simple yet effective · Extreme Sustain",
  image: dinoCompIcon,
  tags: ["Compression"],
  modes: [
    {
      id: "dino_min",
      name: "Minimum",
      description:
        "Lowest compression amount, perfect for subtle dynamics control.",
      audio: compMin,
      icon: dinoCompIcon,
    },
    {
      id: "dino_mid",
      name: "Medium",
      description:
        "A medium amount of compressor. A good compromise between sustain and dynamics",
      audio: compMid,
      icon: dinoCompIcon,
    },
    {
      id: "dino_max",
      name: "Maximum",
      description:
        "Maximum compression amount, this creates an almost endless amount of sustain.",
      audio: compMax,
      icon: dinoCompIcon,
    },
    {
      id: "dino_dry",
      name: "Bypassed",
      description:
        "Dry amplifier tone running through the Nassau with everything at 5",
      audio: compDry,
      icon: dinoCompIcon,
    },
  ],
}


const OD296 = {
  id: "pedal-4",
  name: "OD296 Speciale Overdrive",
  subtitle: "Fat Drive · Toggleable Clean Boost",
  image: od296Icon,
  tags: ["Clean Boost", "Overdrive"],
  modes: [
    {
      id: "pedal_overdrive",
      name: "Overdrive",
      description:
        "Standard overdrive boost settings, drive at 0 with Level at 10.",
      audio: odAudioDrive,
      icon: od296Icon,
    },
    {
      id: "pedal_overdrive_fat",
      name: "Fat Overdrive",
      description:
        "Standard overdrive boost with Fat switch enabled.",
      audio: odAudioDriveFat,
      icon: od296Icon,
    },
    {
      id: "pedal_cleanboost",
      name: "Clean Boost",
      description:
        "Working as a clean boost with full drive. This mode bypasses the internal clippers, resulting in a large head room clean boost.",
      audio: odAudioDriveClean,
      icon: od296Icon,
    },
    {
      id: "pedal_bypassed",
      name: "Bypassed",
      description:
        "Dry amplifier tone running through the Cobalt with everything at 5",
      audio: odAudioDry,
      icon: od296Icon,
    },
  ],
}

export const PEDALS = [
  SF90,
  VE8,
  DINO,
  OD296
];